import { create } from 'zustand';

type Theme = 'dark' | 'light';

interface ThemeState {
  theme: Theme;
  toggle: () => void;
  setTheme: (t: Theme) => void;
}

const getInitial = (): Theme => {
  try {
    const stored = localStorage.getItem('wiki-theme');
    if (stored === 'light' || stored === 'dark') return stored;
  } catch {
    return 'dark';
  }
  return 'dark';
};

function applyTheme(theme: Theme): void {
  document.documentElement.setAttribute('data-theme', theme);
}

export const useTheme = create<ThemeState>((set) => ({
  theme: getInitial(),
  toggle: () => set((s) => {
    const next = s.theme === 'dark' ? 'light' : 'dark';
    applyTheme(next);
    try { localStorage.setItem('wiki-theme', next); } catch { /* storage unavailable */ }
    return { theme: next };
  }),
  setTheme: (t) => {
    applyTheme(t);
    try { localStorage.setItem('wiki-theme', t); } catch { /* storage unavailable */ }
    set({ theme: t });
  },
}));

// Apply on load
const initial = getInitial();
applyTheme(initial);
